"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=void 0;var _default=()=>/**
   * Repeats a string (testing helper)
   *
   * @param {string} echo The string
   * @param {*} [repeat=1] Number of times to repeat the string
   * @return {Promise<radspec/evaluator/TypedValue>}
   */async function(echo){let repeat=1<arguments.length&&arguments[1]!==void 0?arguments[1]:1;return{type:"string",value:echo.repeat(+repeat)}};exports.default=_default;
